import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Box, Grid } from "@material-ui/core";

import useStyles from "./styles";

function TabTypeSchedulling(props) {
  const {
    value,
    index,
    setTab,
    editingItem,
    setEditingItem,
    loadTypes,
    setConfirmed,
    holdConfigs,
    ...other
  } = props;
  const classes = useStyles();
  const [showOptionScreen, setShowOptionScreen] = useState(false);

  const handleLoadTypeSelect = (id) => {
    if (id === 2 && !showOptionScreen) {
      setShowOptionScreen(true);
    }
    if (id === 2 && showOptionScreen) {
      setEditingItem({
        ...editingItem,
        loadingType: 2,
      });
      setTab(1);
      setShowOptionScreen(false);
    }
    if (id === 1) {
      setEditingItem({
        loadingType: id,
      });
      setTab(1);
      setShowOptionScreen(false);
    }
    holdConfigs(true);
    setConfirmed(false);
  };

  useEffect(() => {
    value === 0 && holdConfigs(false);
  }, [value, holdConfigs]);

  return (
    <>
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      />
      {value === index && (
        <div className={classes.selectionType}>
          {showOptionScreen ? (
            <>
              <h2>Selecione o tipo de Origem</h2>
              <Box
                height="100%"
                bgcolor="white"
                width="100%"
                justifyContent="center"
                alignItems="center"
                display="flex"
                flexDirection="row"
              >
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  data-cy="cargill-btn"
                  id="cargill-btn"
                  className={classes.dichargeButton}
                  onClick={() => {
                    handleLoadTypeSelect(2);
                    setEditingItem({
                      loadingType: 2,
                      originType: "cargill",
                    });
                  }}
                >
                  Cargill
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  data-cy="outher-btn"
                  id="outher-btn"
                  className={classes.dichargeButton}
                  onClick={() => {
                    handleLoadTypeSelect(2);
                    setEditingItem({
                      loadingType: 2,
                      originType: "outros",
                    });
                  }}
                >
                  Outros
                </Button>
              </Box>
            </>
          ) : (
            <>
              <h2>Selecione o tipo de agendamento</h2>
              <Box
                height="100%"
                bgcolor="white"
                width="100%"
                justifyContent="center"
                alignItems="center"
                display="flex"
                flexDirection="row"
              >
                {loadTypes.map((type, index) => (
                  <Button
                    key={index}
                    color="primary"
                    variant="contained"
                    data-cy="load-type-btn"
                    id="load-type-btn"
                    size="large"
                    className={classes.dichargeButton}
                    onClick={() => handleLoadTypeSelect(type.id)}
                  >
                    {type.description}
                  </Button>
                ))}
              </Box>
            </>
          )}
        </div>
      )}

      {showOptionScreen && (
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <div
              style={{
                display: "flex",
                height: 56,
                justifyContent: "flex-start",
                marginTop:"5rem"
              }}
            >
              <Button
                onClick={() => setShowOptionScreen(false)}
                className={classes.dischargeButton}
                variant="contained"
                color="primary"
                data-cy="tab-type-back"
                id="tab-type-back"
                style={{ minWidth: "50%" }}
                size="small"
              >
                Voltar
              </Button>
            </div>
          </Grid>
        </Grid>
      )}
    </>
  );
}

TabTypeSchedulling.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  setTab: PropTypes.func.isRequired,
  editingItem: PropTypes.object,
  setEditingItem: PropTypes.func.isRequired,
  loadTypes: PropTypes.array.isRequired,
};

export default TabTypeSchedulling;
